import * as $http from 'axios'

export default {
    get: orderId => $http.get(`v2/orders/${orderId}`),
}
